<template>
  <VLayout column-basis="small" column-spacing="small" class="layout-gap">
    <div v-for="(value, lang) in linksList" :key="lang">
      <LinkWrapper :href="value" class="anchor-btn">
        <VButton :icon="`${lang.toLowerCase()}-color`" :label="lang" class="sdk-documentation-button" />
      </LinkWrapper>
    </div>
  </VLayout>
</template>
<script setup lang="ts">
import { VLayout, VButton } from '@vonage/vivid-vue';
import { computed } from 'vue';
import LinkWrapper from '@/components/markdown/widgets/LinkWrapper.vue';

const props = defineProps({ encodedData: { type: String, required: true } });
const linksList = computed(() => JSON.parse(decodeURIComponent(props.encodedData)));
</script>
<style scoped lang="scss">
.sdk-documentation-button {
  --vvd-button-accent-faint: var(--dp-color-neutral-50-rgb);
  --vvd-button-accent-soft: var(--vvd-color-neutral-100);
}
</style>
